var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-footer font-weight-bold text-center"},[(_vm.editMode)?_c('div',[_c('RichTextEditor',{attrs:{"maxheight":"short","value":_vm.footerShow},on:{"input":(v) => _vm.$emit('updateFooter', v)}})],1):_c('div',{domProps:{"innerHTML":_vm._s(_vm.footerShow)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }